import React, { useContext } from "react";
import { Grid, IconButton } from "@mui/material";
import Form from "../../components/form";
import api from "../../services/api";
import AuthContext from "../../auth/context";
import { useHistory } from "react-router-dom";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import AppContext from "../../pages/app/context";

export default function AlteracaoSenha() {
  const usuario = useContext(AuthContext);
  const history = useHistory();
  const { notification } = useContext(AppContext);

  const salvar = (form) => {
    if (!form.senhaAtual) {
      return notification("warning", "Informe a senha atual.");
    }

    if (form.novaSenha.length < 3 || !form.novaSenha) {
      return notification(
        "warning",
        "A senha deverá ter no mínimo três caracteres."
      );
    }

    if (form.novaSenha !== form.confirmacaoNovaSenha) {
      return notification(
        "warning",
        "A confirmação da senha é diferente da senha informada."
      );
    }

    api
      .post("usuarios/alterarSenha", {
        id: usuario.usuario.id,
        senhaAtual: form.senhaAtual,
        novaSenha: form.novaSenha,
      })
      .then((res) => {
        if (res.data.includes(200)) {
          notification("success", "Senha alterada com sucesso!");
          return history.push("perfil");
        }

        if (res.data.includes(401)) {
          return notification("warning", "Senha atual é inválida.");
        }

        notification("error", "Não foi possível alterar a senha.");
      })
      .catch((err) => alert(err));
  };

  const fSenha = {
    form: {
      senhaAtual: {
        label: "Senha atual",
        type: "password",
      },
      novaSenha: {
        label: "Nova senha",
        type: "password",
      },
      confirmacaoNovaSenha: {
        label: "Confirme nova senha",
        type: "password",
      },
    },
    submit: {
      label: "confirmar",
      action: salvar,
    },
  };

  return (
    <>
      <div style={{ display: "flex" }}>
        <IconButton onClick={() => history.push("perfil")}>
          <ChevronLeftIcon></ChevronLeftIcon>
        </IconButton>
        <h2>Alterar senha</h2>
      </div>
      <Grid container>
        <Form formData={fSenha} />
      </Grid>
    </>
  );
}
